export default {"src":"/_next/static/media/text.ec0fc0a8.svg","height":40,"width":40};